<template>
    <v-dialog
        v-model="addEditGroupDialogHandle"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAddEditGroupDialog()"
        @click:outside="closeAddEditGroupDialog()"
    >
        <v-card>
            <v-form @submit.prevent.native="addEditAGroup()">
                <v-toolbar color="primary" dark :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="isAdd ? icons.mdiPlusCircleOutline : icons.mdiPencilCircleOutline"
                            class="mr-3"></v-icon>
                    <div v-text="$gettext('Add Group')" v-if="isAdd"></div>
                    <div v-text="$gettext('Edit Group')" v-else-if="isEdit"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditGroupDialog()"
                            v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="addEditAGroup()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    v-model="chosenGroupType"
                                    :items="groupTypes"
                                    item-text="value"
                                    item-value="key"
                                    :label="$gettext('Group Type')"
                                    :placeholder="$gettext('Group Type')"
                                    outlined
                                    :prepend-inner-icon="icons.mdiSelectGroup"
                                >
                                </v-select>

                                <v-autocomplete
                                    :items="predefinedDomains"
                                    item-text="domain"
                                    item-value="domain"
                                    outlined
                                    :label="$gettext('Domain you are looking for')"
                                    v-if="isChosenGroupTypePredefined"
                                    v-model="chosenPredefinedDomain"
                                    :search-input.sync="search"
                                    :loading="loading"
                                >
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{
                                                        $gettextInterpolate($gettext('%{ searchedDomain } is not in our list.'), {searchedDomain: search || ''})
                                                    }}
                                                    <a @click="switchToCustomFromPredefined()">{{
                                                            $gettext('Continue as a custom domain.')
                                                        }}</a>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:append-outer>
                                        <v-slide-x-reverse-transition mode="out-in">
                                            <v-icon v-text="icons.mdiHeadQuestion"></v-icon>
                                        </v-slide-x-reverse-transition>
                                    </template>
                                </v-autocomplete>

                                <v-row v-if="chosenPredefinedDomain" class="mb-3">
                                    <v-col>

                                        <div class="subtitle-2 font-weight-bold mb-2">{{
                                                $gettext('Includes Domains:')
                                            }}
                                        </div>

                                        <v-chip-group
                                        >
                                            <v-chip
                                                v-for="(suggestion, index) in suggestionsForChosenPredefinedDomain"
                                                :key="index"
                                                :value="suggestion"
                                                outlined
                                                color="primary"
                                                text-color="primary"
                                                class="ma-1"
                                            >
                                                {{ suggestion }}
                                            </v-chip>
                                        </v-chip-group>

                                        <div class="my-1 caption">{{
                                                $gettextInterpolate($gettext('It is observed that these domains are required for proper functioning of %{ website }.'), {
                                                    website: chosenPredefinedDomain || ''
                                                })
                                            }}
                                        </div>

                                    </v-col>
                                </v-row>

                                <!--                                v-if="isChosenGroupTypeCustom || (isChosenGroupTypePredefined && chosenPredefinedDomain)"-->

                                <v-text-field
                                    :label="$gettext('Group Name')"
                                    :placeholder="$gettext('Group Name')"
                                    required
                                    v-model="addEditGroupName"
                                    :error-messages="addEditGroupNameErrors"
                                    outlined
                                    @input="$v.addEditGroupName.$touch()"
                                    @blur="$v.addEditGroupName.$touch()"
                                    autofocus
                                    clearable
                                    :prepend-inner-icon="icons.mdiSelectGroup"
                                ></v-text-field>

                                <!--                                v-if="folderOptions.length > 1 && ((isChosenGroupTypePredefined && chosenPredefinedDomain) || isChosenGroupTypeCustom)"-->
                                <v-autocomplete
                                    :items="folderOptions"
                                    item-text="value"
                                    item-value="key"
                                    :label="$gettext('Folder')"
                                    :placeholder="$gettext('Folder')"
                                    v-model="addEditGroupFolder"
                                    outlined
                                    clearable
                                    :prepend-inner-icon="!addEditGroupFolder ? icons.mdiSlashForward : icons.mdiFolderOutline"
                                >
                                    <template v-slot:item="{ props, item, on, attrs }">
                                        <v-list-item v-on="on" v-bind="attrs">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-icon
                                                        v-text="item.value !== 'Root' ? icons.mdiFolderOutline : icons.mdiSlashForward"
                                                        class="small primary--text mr-1"></v-icon>
                                                    {{ item.value }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddEditGroupDialog()"
                           v-text="$gettext('Close')"></v-btn>
                    <v-btn color="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import {required} from 'vuelidate/lib/validators'
import {debounce} from 'lodash'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapWritableState} from "pinia";
import {useGroupsStore} from "@/stores/GroupsStore";
import axios from "axios";

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinVuelidate],
    props: {
        groupsProp: {
            required: true,
            type: Array | Object
        },
        addEditGroupDialog: {
            required: true,
            type: Boolean,
            default: false
        },
        addEditGroupFolderProp: {
            required: false,
            type: String,
            default: ''
        },
        mode: {
            type: String, // Expected: add/edit
            required: true,
            default: '',
        },

        addEditGroupDefaultFolder: {
            required: false,
            type: String | Boolean,
            default: ''
        },

        inEditGroupName: {
            required: false,
            default: ''
        },

    },
    data() {
        return {

            addEditGroupName: '',
            addEditGroupDialogHandle: '',
            addEditGroupFolder: '',
            folderOptions: [],

            /**
             * @type {String}
             * options: custom, predefined */
            chosenGroupType: 'predefined',
            groupTypes: [
                {
                    key: 'predefined',
                    value: this.$gettext('Predefined')
                },
                {
                    key: 'custom',
                    value: this.$gettext('Custom')
                },
                
            ],

            chosenPredefinedDomain: '',

            search: '',
            loading: false,
            predefinedDomains: [],
            suggestionsForChosenPredefinedDomain: [],

        }
    },
    watch: {
        /**
         * When a popup is closed, the previous entry is left as is.
         * Also, when a popup is opened with other entry the value is not refreshed, with the new one, if we don't have this.
         * @param newVal
         */
        addEditGroupDialog(newVal) {

            let self = this

            if (!newVal) {
                self.resetForm()
            } else {
                self.addEditGroupName = self.$props.inEditGroupName
                self.addEditGroupFolder = ''
                if (self.$props.addEditGroupFolderProp) {
                    self.addEditGroupFolder = self.addEditGroupFolderProp
                }
                if (self.$props.addEditGroupDefaultFolder && self.$props.mode === 'add') {
                    self.addEditGroupFolder = self.$props.addEditGroupDefaultFolder
                }
            }

        },
        search(val) {
            if (!val || val.length < 3) {
                this.loading = false
                this.predefinedDomains = []
                return
            }
            
            if (val !== this.chosenPredefinedDomain) {
                this.loading = true
                this.debouncedQuery(val)
            }
        },

        chosenPredefinedDomain: {
            handler: function (val) {
                this.setSuggestionsForChosenPredefinedDomain()
            },
        }

    },

    created() {
        this.debouncedQuery = debounce(this.querySelections, 400)
    },

    mounted() {

        let self = this

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.addEditGroupName = self.$props.inEditGroupName
        self.addEditGroupDialogHandle = self.$props.addEditGroupDialog
        self.addEditGroupFolder = ''

        self.folderOptions = []
        self.folderOptions.push({
            key: '',
            value: self.$gettext('Root')
        })

        self.allFolders().forEach((group) => {
            self.folderOptions.push({
                key: group.key,
                value: group.key
            })
        })

        if (self.$props.addEditGroupFolderProp) {
            self.addEditGroupFolder = self.addEditGroupFolderProp
        }

        if (self.$props.addEditGroupDefaultFolder && self.$props.mode === 'add') {
            self.addEditGroupFolder = self.$props.addEditGroupDefaultFolder
        }


    },

    beforeDestroy() {
        this.debouncedQuery.cancel()
    },

    methods: {

        setSuggestionsForChosenPredefinedDomain() {

            let self = this;

            self.suggestionsForChosenPredefinedDomain = [];

            let suggestionsForChosenPredefinedDomain = this.predefinedDomains.filter(d => d.domain === self.chosenPredefinedDomain)

            if (suggestionsForChosenPredefinedDomain && suggestionsForChosenPredefinedDomain.length > 0) {
                self.suggestionsForChosenPredefinedDomain = JSON.parse(suggestionsForChosenPredefinedDomain[0]['suggestions'])[1];
            }

        },

        async querySelections(searchQuery) {

            let self = this;
            self.loading = true

            try {

                let groupsSuggestionsRequest = await axios.get('groups.php?domain=' + searchQuery + '&action=getAListOfDomains')

                if (groupsSuggestionsRequest) {

                    self.predefinedDomains = groupsSuggestionsRequest?.data?.data['domainsAndSuggestions'];

                    if (self.predefinedDomains && self.predefinedDomains.length > 0) {
                        self.predefinedDomains = self.predefinedDomains.filter(e => {
                            return (e.domain || '').toLowerCase().indexOf((searchQuery || '').toLowerCase()) > -1
                        })
                    } else {
                        self.predefinedDomains = [];
                    }

                }

            } catch (e) {
                console.log(e)
            } finally {
                self.loading = false
            }


        },

        switchToCustomFromPredefined() {
            let self = this
            self.chosenGroupType = 'custom'
            self.addEditGroupName = JSON.parse(JSON.stringify(self.search));
        },

        allFolders() {
            return this.groups.filter((group) => {
                return (group.hasOwnProperty('child'));
            })
        },
        addEditAGroup() {

            let self = this
            self.$v.$touch()

            if (!self.$v.$invalid) {

                if (self.isAdd) {

                    let destDomains = []
                    if (self.isChosenGroupTypePredefined) {
                        destDomains = [...destDomains, ...self.suggestionsForChosenPredefinedDomain]
                    }

                    self.$emit('group-added',
                        {
                            key: self.addEditGroupName,
                            value: {
                                dest_domains: destDomains
                            }
                        },
                        self.addEditGroupFolder
                    )
                } else {
                    self.$emit('group-updated', self.addEditGroupName, self.addEditGroupFolder)
                }

                self.closeAddEditGroupDialog()
                self.resetForm()

            }

        },

        closeAddEditGroupDialog() {
            let self = this
            self.$emit('close-add-edit-group-dialog', 'addEditGroupDialog')
        },
        resetForm() {
            let self = this
            self.addEditGroupName = ''
            self.addEditGroupFolder = ''
            self.$v.$reset()
        },
    },
    computed: {

        isAdd() {
            return this.$props.mode === 'add'
        },
        isEdit() {
            return this.$props.mode === 'edit'
        },
        addEditGroupNameErrors() {
            const errors = []
            if (!this.$v.addEditGroupName.$dirty) return errors
            !this.$v.addEditGroupName.required && errors.push(this.$gettext('Group name is required.'))
            !this.$v.addEditGroupName.isUnique && errors.push(this.$gettext('We already have this group name with us.'))
            !this.$v.addEditGroupName.doesNotContainSlash && errors.push(this.$gettext('"/" is not an allowed character for the group name'))
            return errors
        },
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
            currentSelectedGroup: 'currentSelectedGroup',
            currentSelectedGroupName: 'currentSelectedGroupName',
        }),
        isChosenGroupTypePredefined() {
            return this.chosenGroupType === 'predefined'
        },
        isChosenGroupTypeCustom() {
            return this.chosenGroupType === 'custom'
        },

    },
    validations: {
        addEditGroupName: {
            required,
            async doesNotContainSlash(value, vm) {
                return !value.includes('/');
            },
            async isUnique(value, vm) {
                let allowedValue = vm.mode === 'edit' ? vm.$props.inEditGroupName : null
                return await this.vuelidateIsUniqueForKeyValueType(value, this.$props.groupsProp, allowedValue)
            }
        }
    }

}
</script>

<style type="text/scss">
.add-group-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>
